import { all, call, put, takeLatest } from 'redux-saga/effects';
import {
  GET_PHAN_QUYEN_CAM_DO,
  GET_PHAN_QUYEN_TIN_CHAP,
  GET_PHAN_QUYEN_NO_PHAI_THU,
  GET_PHAN_QUYEN_TRA_GOP,
} from 'actions/PhanQuyen/actionTypes';
import {
  getPhanQuyenCamDoSuccess,
  getPhanQuyenCamDoFailure,
  getPhanQuyenTinChapSuccess,
  getPhanQuyenTinChapFailure,
  getPhanQuyenNoPhaiThuSuccess,
  getPhanQuyenNoPhaiThuFailure,
  getPhanQuyenTraGopSuccess,
  getPhanQuyenTraGopFailure,
} from 'actions/PhanQuyen';
import PhanQuyenApi from 'service/phanQuyenApi';
import { pushNotification } from 'utils/notifications';

function* getPhanQuyenCamDo(action) {
  try {
    const response = yield call(PhanQuyenApi.phanQuyenCamDo, action.dataSearch);
    if (response.ok) {
      yield put(getPhanQuyenCamDoSuccess(response.data));
    } else {
      pushNotification('Lỗi xảy ra', 'error', 'TOP_CENTER', 1000);
      yield put(getPhanQuyenCamDoFailure());
    }
  } catch (error) {
    pushNotification('Lỗi xảy ra', 'error', 'TOP_CENTER', 1000);
    yield put(getPhanQuyenCamDoFailure());
  }
}

function* getPhanQuyenTinChap(action) {
  try {
    const response = yield call(
      PhanQuyenApi.phanQuyenTinChap,
      action.dataSearch
    );
    if (response.ok) {
      yield put(getPhanQuyenTinChapSuccess(response.data));
    } else {
      pushNotification('Lỗi xảy ra', 'error', 'TOP_CENTER', 1000);
      yield put(getPhanQuyenTinChapFailure());
    }
  } catch (error) {
    pushNotification('Lỗi xảy ra', 'error', 'TOP_CENTER', 1000);
    yield put(getPhanQuyenTinChapFailure());
  }
}

function* getPhanQuyenNoPhaiThu(action) {
  try {
    const response = yield call(
      PhanQuyenApi.phanQuyenNoPhaiThu,
      action.dataSearch
    );
    if (response.ok) {
      yield put(getPhanQuyenNoPhaiThuSuccess(response.data));
    } else {
      pushNotification('Lỗi xảy ra', 'error', 'TOP_CENTER', 1000);
      yield put(getPhanQuyenNoPhaiThuFailure());
    }
  } catch (error) {
    pushNotification('Lỗi xảy ra', 'error', 'TOP_CENTER', 1000);
    yield put(getPhanQuyenNoPhaiThuFailure());
  }
}
function* getPhanQuyenTraGop(action) {
  try {
    const response = yield call(
      PhanQuyenApi.phanQuyenTraGop,
      action.dataSearch
    );
    if (response.ok) {
      yield put(getPhanQuyenTraGopSuccess(response.data));
    } else {
      pushNotification('Lỗi xảy ra', 'error', 'TOP_CENTER', 1000);
      yield put(getPhanQuyenTraGopFailure());
    }
  } catch (error) {
    pushNotification('Lỗi xảy ra', 'error', 'TOP_CENTER', 1000);
    yield put(getPhanQuyenTraGopFailure());
  }
}
function* watchGetRequest() {
  yield takeLatest(GET_PHAN_QUYEN_CAM_DO, getPhanQuyenCamDo);
  yield takeLatest(GET_PHAN_QUYEN_TIN_CHAP, getPhanQuyenTinChap);
  yield takeLatest(GET_PHAN_QUYEN_NO_PHAI_THU, getPhanQuyenNoPhaiThu);
  yield takeLatest(GET_PHAN_QUYEN_TRA_GOP, getPhanQuyenTraGop);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
